import { render, staticRenderFns } from "./ContainerKCPInformationDocuments.vue?vue&type=template&id=1ea2236a&"
import script from "./ContainerKCPInformationDocuments.vue?vue&type=script&lang=js&"
export * from "./ContainerKCPInformationDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ContainerKCPInformationDocuments.vue?vue&type=style&index=0&id=1ea2236a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports